import { integer, pgSchema, text, timestamp } from "drizzle-orm/pg-core";

//#region src/schema/migrationsSchema.ts
const drizzleSchema = pgSchema("drizzle");
const codeMigrations = drizzleSchema.table("code_migrations", {
	name: text("name").primaryKey(),
	version: integer("version").notNull(),
	appliedAt: timestamp("applied_at").defaultNow().notNull()
});

//#endregion
export { codeMigrations, drizzleSchema };